/**
 * SellingTips.jsx — compact stat grid for issue #96.
 *
 * Reusable across the Item Analysis widget (ItemDetail) and the
 * detail popup (ItemDetailModal). Renders nothing when there's no
 * sample to summarise so callers can drop it in unconditionally.
 *
 * Each stat carries a `title` tooltip explaining the rolling window;
 * matches the per-stat tooltips called out in the issue's AC.
 */

import { Show } from 'solid-js';
import { qty } from '../lib/format.js';

export default function SellingTips(props) {
  const tips = () => props.tips || null;
  const win  = () => tips()?.windowDays || 30;
  const winLabel = () => `last ${win()} days`;

  return (
    <Show when={tips() && tips().sampleSize > 0}>
      <div class="v2-section-h" title={`Aggregates over ${winLabel()}.`}>
        Selling tips · <span class="v2-section-h__sub">{winLabel()}</span>
      </div>
      <div class="v2-stat-grid v2-selling-tips">
        <div class="v2-stat" title={`Median quantity per sale across the ${winLabel()}.`}>
          <span class="v2-stat__label">Typical stack</span>
          <span class="v2-stat__value">×{qty(tips().medianStack)}</span>
          <span class="v2-stat__sub">median quantity</span>
        </div>
        <div class="v2-stat" title={`Average sales per day across the ${winLabel()} (${qty(tips().sampleSize)} sales total).`}>
          <span class="v2-stat__label">Sales / day</span>
          <span class="v2-stat__value">{tips().salesPerDay}</span>
          <span class="v2-stat__sub">{qty(tips().sampleSize)} sales · {winLabel()}</span>
        </div>
        <div class="v2-stat" title={`Average units sold per day across the ${winLabel()}.`}>
          <span class="v2-stat__label">Volume / day</span>
          <span class="v2-stat__value">{qty(tips().volumePerDay)}</span>
          <span class="v2-stat__sub">units</span>
        </div>
        <Show when={tips().bestGuild}>
          <div class="v2-stat" title={`Highest unit volume in the ${winLabel()}.`}>
            <span class="v2-stat__label">Best guild</span>
            <span class="v2-stat__value v2-stat__value--small">{tips().bestGuild.guildName}</span>
            <span class="v2-stat__sub">{qty(tips().bestGuild.saleCount)} sales · {qty(tips().bestGuild.volume)} units</span>
          </div>
        </Show>
      </div>
    </Show>
  );
}
